import { combineReducers } from '@reduxjs/toolkit';
import createCrossReferenceReducer from './create/createSlice';
import crossReferenceListReducer from './list/listSlice';
import deleteCrossReferenceReducer from './delete/deleteSlice';

const crossReferenceSlice = combineReducers({
    create: createCrossReferenceReducer,
    list: crossReferenceListReducer,
    delete: deleteCrossReferenceReducer,
});

export default crossReferenceSlice;
